import { makeStyles } from "@material-ui/core/styles";

const useContactFormStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(3),
    },
    background: '#ffffff',
    padding: theme.spacing(5),
    borderRadius: '20px',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.1)',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '4px',
      background: 'linear-gradient(90deg, #00d4aa, #667eea)',
    },
  },
  rootTextField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '10px',
      fontFamily: "'Inter', 'Segoe UI', sans-serif",
      fontSize: '1.1rem',
      '& fieldset': {
        borderColor: '#e2e8f0',
        borderWidth: '2px',
      },
      '&:hover fieldset': {
        borderColor: '#00d4aa',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#00d4aa',
        boxShadow: '0 0 20px rgba(0, 212, 170, 0.2)',
      },
      '&.Mui-error fieldset': {
        borderColor: '#ef4444 !important',
        borderWidth: '2px',
      },
      '&.Mui-error:hover fieldset': {
        borderColor: '#dc2626 !important',
      },
      '&.Mui-error.Mui-focused fieldset': {
        borderColor: '#dc2626 !important',
        boxShadow: '0 0 20px rgba(239, 68, 68, 0.2)',
      },
      '&.Mui-disabled': {
        backgroundColor: '#f8fafc',
        '& fieldset': {
          borderColor: '#cbd5e0',
        },
        '& input': {
          color: '#0a1628 !important',
          fontWeight: '600',
        },
        '& input::placeholder': {
          color: '#64748b !important',
          opacity: 1,
        },
      },
    },
    '& .MuiInputLabel-root': {
      fontFamily: "'Inter', 'Segoe UI', sans-serif",
      fontSize: '1.05rem',
      '&.Mui-focused': {
        color: '#0a1628',
      },
      '&.Mui-error': {
        color: '#ef4444 !important',
      },
      '&.Mui-disabled': {
        color: '#475569 !important',
      },
    },
    '& .MuiFormHelperText-root': {
      fontFamily: "'Inter', 'Segoe UI', sans-serif",
      fontSize: '0.9rem',
      marginTop: theme.spacing(0.5),
      
      '&.Mui-error': {
        color: '#ef4444',
        fontWeight: '500',
      },
    },
  },
  input: {
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    fontSize: '1.1rem',
  },
  rootButton: {
    color: '#ffffff',
    background: 'linear-gradient(135deg, #0a1628 0%, #1a365d 100%)',
    borderRadius: '10px',
    border: 0,
    height: 58,
    padding: '0 40px',
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    fontWeight: 600,
    fontSize: '1.15rem',
    textTransform: 'none',
    boxShadow: '0 4px 20px rgba(10, 22, 40, 0.3)',
    transition: 'all 0.4s ease',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '-100%',
      width: '100%',
      height: '100%',
      background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
      transition: 'left 0.5s ease',
    },
    '&:hover:not(:disabled)': {
      background: 'linear-gradient(135deg, #00d4aa 0%, #667eea 100%)',
      boxShadow: '0 8px 40px rgba(0, 212, 170, 0.5)',
      transform: 'translateY(-3px)',
      '&::before': {
        left: '100%',
      },
    },
    '&:disabled': {
      background: 'linear-gradient(135deg, #cbd5e0 0%, #a0aec0 100%)',
      boxShadow: '0 2px 8px rgba(10, 22, 40, 0.15)',
      transform: 'none',
      cursor: 'not-allowed',
      opacity: 0.6,
    },
  },
}));
export default useContactFormStyles;
